export interface SupportContact {
  name: string;
  phone: string;
  email: string;
  whatsApp: string;
}

export const SUPPORT_CONTACT: SupportContact = {
  name: 'Vladimir Milošević',
  phone: '062283315',
  email: 'support@anihis.com',
  whatsApp: '062283315',
};
